<template>
  <v-row v-if="$userProfile">
    <v-col cols="12">
      <v-card-container>
        <UserDataComponent :user="$userProfile.profile" />
      </v-card-container>
    </v-col>

    <v-col cols="12">
      <v-card-container>
        <UserSettingsComponent />
      </v-card-container>
    </v-col>

    <v-col cols="12">
      <v-card-container>
        <UserPermissionComponent :user="$userProfile.profile" />
      </v-card-container>
    </v-col>
  </v-row>
</template>

<script setup>
import UserDataComponent from '@/components/common/user/UserDataComponent';
import UserPermissionComponent from '@/components/common/user/UserPermissionComponent';
import UserSettingsComponent from '@/components/account/UserSettingsComponent';
import useScopesStore from '@/stores/scopes';

const scopesStore = useScopesStore();
const { updateSelectedScope } = scopesStore;

// Hooks
updateSelectedScope({ data: null, type: null });
</script>
